import { Injectable } from '@angular/core';

import { BemCombustivel } from "./bem-combustivel.model";
import { apiName } from "./data.service";
import { RestService } from "../../core/services/rest.service";

@Injectable()
export class BemCombustivelApiService {

    constructor(
        private _restService: RestService
    ) { }

    onPost(object: BemCombustivel, done: any) {
        this._restService.onPost(apiName, object, done);
    }

    onPut(object: BemCombustivel, done: any) {
        this._restService.onPut(apiName, object, done);
    }

    onDelete(objectId: number, done: any) {
        this._restService.onDelete(apiName, objectId, done);
    }

    onGetByBem(bemId: number, done: any) {
        let filter: any = {"where":{"bemId":bemId,"ativo":true},"include":["combustivel"]};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetById(objectId: number, done: any) {
        this._restService.onGet(apiName + '/' + objectId + '?', done);
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/bem-combustiveis/bem-combustivel-api.service.ts
 **/